import { useState } from "react"
import { BsBarChartLine, BsBarChartLineFill } from "react-icons/bs"
import { RiTableFill, RiTableLine } from "react-icons/ri"

export type Props = {
    isChartMode:boolean;
    setModeHandler:()=>void;
    tooltipId:string;
}

const DataSwitcherComponent: React.FC<Props> = ({ isChartMode, setModeHandler, tooltipId }) => {

  const [isChartSwitcherState, setChartSwitcherState] = useState<boolean>(isChartMode);
  const chartClasses = (isChartSwitcherState ? ' active': '');
  const tableClasses = (!isChartSwitcherState ? ' active': '');
  
  const style1 = { color: "#ffffff", fontSize: 16 }
  const style2 = { color: "#656667", fontSize: 16 }

  const handleClick=()=>{
    setChartSwitcherState(!isChartSwitcherState)
    setModeHandler()
  }

  const getAriaLabel = () => 
    isChartSwitcherState 
    ? "Passer en vue tableau"
    : "Passer en vue graphique";

  return (
    <button 
      data-tip
      data-for={ tooltipId }
      className="data-switcher"
      aria-label={ getAriaLabel() }
    >
      <div className={`switcher-left-side${chartClasses}`} onClick={handleClick}>
          {
            isChartSwitcherState
            ? <BsBarChartLineFill style={style1}></BsBarChartLineFill>
            : undefined
          }
          {
            !isChartSwitcherState
            ? <BsBarChartLine style={style2}></BsBarChartLine>
            : undefined
          }
      </div>
      <div className={`switcher-right-side${tableClasses}`} onClick={handleClick}>
          {
            !isChartSwitcherState
            ? <RiTableFill style={style1}></RiTableFill>
            : undefined
          }
          {
            isChartSwitcherState
            ? <RiTableLine style={style2}></RiTableLine>
            : undefined
          }
      </div>
    </button>
  );
}

export default DataSwitcherComponent